import createReactComponent from '../createReactComponent';
export default createReactComponent('delta', 'IconDelta', [
  ['path', { d: 'M4 20h16l-8 -16z', key: 'svg-0' }],
]);
